<template>
  <li class="more el-icon icon-sub-menu">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" :style="[(active == true) ? {color: '#B0893C'} : {}]" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
      <path d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z" fill="#00000"></path>
      <path d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z" fill="#00000"></path>
    </svg>
  </li>
</template>

<script>
  export default {
    props: ['active'],
  }
</script>
